import React from "react";
import PropTypes from "prop-types";

import "assets/scss/material-dashboard-pro-react/plugins/_plugin-react-datepicker.css";
import styles from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import login from "api/authentication/login.js";
import SweetAlert from "react-bootstrap-sweetalert";
import FooterDownloadContainer from "container/FooterDownloadContainer.js";
// react component for creating dynamic tables
// @material-ui/core components
// import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import InputAdornment from "@material-ui/core/InputAdornment";

Object.assign(styles, {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  restaurantName: {
    textAlign: "center"
  }
});

export default function Login() {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState(false);
  const [popup, setPopup] = React.useState(false);
  const [popupText, setPopupText] = React.useState("");
  const [popupTitle, setPopupTitle] = React.useState("");
  return (
    <div style={{ backgroundColor: "white" }}>
      <div className="main-banner-home" style={{ backgroundColor: "#eee" }}>
        {popup ? (
          <div className="sweet-alert-error">
            <SweetAlert
              // success
              warning
              style={{ display: "block", marginTop: "-100px" }}
              title={popupTitle}
              onConfirm={() => {
                setPopup(false);
              }}
              confirmBtnCssClass={"show-more-results"}
              // // confirmBtnCssClass={
              // //   'button__clear'
              // //
              // // }
              // cancelBtnCssClass={"default_reverse no_hover"}
              confirmBtnText={"Ok"}
              onCancel={() => {
                setPopup(false);
              }}
            >
              <div className={"reservation-popup-text"}>{popupText}</div>
            </SweetAlert>
          </div>
        ) : null}
        <div style={{ padding: 10 }}>
          <div
            style={{
              margin: "100px auto",
              maxWidth: "614px",
              minHeight: "450px",
              padding: 10,
              // marginTop: 10,
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
              borderStyle: "solid",
              backgroundColor: "white"
            }}
          >
            <div style={{ margin: "20px" }}>
              <div
                className="main-banner-title container"
                style={{ color: "#3c4858" }}
              >
                LOGIN
              </div>
              <div>
                <CustomInput
                  formControlProps={{ fullWidth: true }}
                  labelText={"Email"}
                  inputProps={{
                    value: email,
                    className: "login-input",
                    startAdornment: (
                      <InputAdornment position="start">
                        <i
                          className={`fa fa-envelope reservation-input-icon`}
                        />
                      </InputAdornment>
                    ),
                    onKeyDown: e => {
                      switch (e.key) {
                        case "Enter":
                          if (!email || !password) {
                            setError(true);
                          } else {
                            login({ email, password }).then(el => {
                              if (el) {
                                setPopup(true);
                                setPopupTitle("Errore login");
                                setPopupText("Controlla i dati immessi");
                              }
                            });
                            // TODO FAI LOGIN
                          }
                          break;
                        default:
                          break;
                      }
                    },
                    onChange: e => {
                      setEmail(e.target.value);
                      if (error) {
                        setError(false);
                      }
                    }
                  }}
                />
              </div>
              <CustomInput
                formControlProps={{ fullWidth: true }}
                labelText={"Password"}
                inputProps={{
                  value: password,
                  className: "login-input",
                  type: "password",
                  startAdornment: (
                    <InputAdornment position="start">
                      <i className={`fa fa-key reservation-input-icon`} />
                    </InputAdornment>
                  ),
                  onKeyDown: e => {
                    switch (e.key) {
                      case "Enter":
                        if (!email || !password) {
                          setError(true);
                        } else {
                          login({ email, password }).then(el => {
                            if (el) {
                              setPopup(true);
                              setPopupTitle("Errore login");
                              setPopupText("Controlla i dati immessi");
                            }
                          });
                          // TODO FAI LOGIN
                        }
                        break;
                      default:
                        break;
                    }
                  },
                  onChange: e => {
                    setPassword(e.target.value);
                    if (error) {
                      setError(false);
                    }
                  }
                }}
              />
              <div className="login-missing-data">
                {error ? "Inserisci tutti i dati necessari" : ""}
              </div>
              <div
                className="reservation-toc-container"
                style={{
                  margin: "20px",
                  width: "calc(100% - 40px)",
                  textAlign: "center",
                  color: "#3c4858"
                }}
              >
                Cliccando su "Login", accetti i nostri Termini e Condizioni e
                confermi di aver letto le nostre{" "}
                <a href={"/policy-privacy"}>Privacy Policy</a> e Cookie Policy.
                Dichiari altresì di aver compiuto sedici anni.
              </div>
              <div
                style={{
                  width: "100%",
                  maxWidth: "614px",
                  display: "flex"
                }}
              >
                {/* <Button
                  color="info"
                  round
                  style={{ margin: "20px auto 0" }}
                  onClick={() => {
                    if (!email || !password) {
                      setError(true);
                    } else {
                      login({ email, password }).then(el => {
                        if (el) {
                          setPopup(true);
                          setPopupTitle("Errore login");
                          setPopupText("Controlla i dati immessi");
                        }
                      });
                      // TODO FAI LOGIN
                    }
                  }}
                >
                  Login
                </Button> */}
                <button
                  className="reservation-button"
                  style={{
                    display: "block",
                    paddingLeft: 20,
                    paddingRight: 20
                  }}
                  onClick={() => {
                    if (!email || !password) {
                      setError(true);
                    } else {
                      login({ email, password }).then(el => {
                        if (el) {
                          setPopup(true);
                          setPopupTitle("Errore login");
                          setPopupText("Controlla i dati immessi");
                        }
                      });
                      // TODO FAI LOGIN
                    }
                  }}
                >
                  Login
                </button>
              </div>
              {/* <div style={{ marginTop: "20px" }}>
            <a
              className="no-account-yet"
              // href="https://foodiestrip.com/business/sign-up/"
              title="foodiestrip - registrati"
            >
              Non hai ancora un account? Registrati
            </a>
          </div> */}
            </div>
          </div>
        </div>
      </div>
      <FooterDownloadContainer />
    </div>
  );
}
Login.propTypes = {
  updateCity: PropTypes.func.isRequired
};
